import pbfe from "./pbfe.js"
import { _, t } from "./i18n.js";

var dialog;
function init(container) {
    dialog = new pbfe.Dialog("");
    t(dialog.title, "Privacy");
    dialog.element.id = "privacyDialog";
    dialog.element.classList.add("glass-dialog");

    // --- Header Section ---
    var header = document.createElement("div");
    header.className = "glass-header";

    var title = document.createElement("h2");
    title.className = "glass-title";
    t(title, "Privacy Policy");
    header.appendChild(title);

    var subtitle = document.createElement("div");
    subtitle.className = "glass-subtitle";
    t(subtitle, "Your Data Stays With You");
    header.appendChild(subtitle);

    dialog.body.appendChild(header);

    // --- Content Section ---
    var content = document.createElement("div");
    content.className = "glass-content";

    // Feature 1: Local Processing
    var item1 = createPrivacyItem(
        "🔒",
        "Zero Uploads",
        "This app runs entirely in your browser. Your images are processed locally and are never uploaded to any server."
    );
    content.appendChild(item1);

    // Feature 2: No Tracking
    var item2 = createPrivacyItem(
        "🛡️",
        "No Tracking",
        "We respect your privacy. We do not collect personal data or track your behavior across the web."
    );
    content.appendChild(item2);

    // Feature 3: Open Source
    var item3 = createPrivacyItem(
        "📖",
        "Transparent",
        "Our code is open. You can verify exactly how your data is handled."
    );
    content.appendChild(item3);

    dialog.body.appendChild(content);

    // --- Footer / Button ---
    dialog.buttons.innerHTML = "";

    var closeBtn = new pbfe.Button("");
    t(closeBtn.element, "Understood & Safe");
    closeBtn.element.className = "glass-btn";
    closeBtn.addEventListener("click", hide);
    dialog.buttons.appendChild(closeBtn.element);

    container.appendChild(dialog);
}

function createPrivacyItem(icon, titleKey, descKey) {
    var item = document.createElement("div");
    item.className = "privacy-item";

    var iconElem = document.createElement("div");
    iconElem.className = "privacy-item-icon";
    iconElem.innerText = icon;
    item.appendChild(iconElem);

    var textContainer = document.createElement("div");
    textContainer.className = "privacy-item-text";

    var title = document.createElement("h3");
    title.className = "privacy-item-title";
    t(title, titleKey);
    textContainer.appendChild(title);

    var desc = document.createElement("div");
    desc.className = "privacy-item-desc";
    t(desc, descKey);
    textContainer.appendChild(desc);

    item.appendChild(textContainer);
    return item;
}

function show() { dialog.show(); }
function hide() { dialog.hide(); }

var privacyDialog = {
    init, show, hide
}
export default privacyDialog;
